<template>
  <v-container>

    <v-card class="mt-8">
      <v-card-title
      >{{ $t("table.finishedForms") }}
        <v-spacer></v-spacer>
        <v-text-field
            v-model="historic_search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
        />
        <v-spacer></v-spacer>
      </v-card-title>

      <v-data-table
          :headers="historic_headers"
          :items="historic_forms"
          :search="historic_search"
          :custom-filter="filterHistoricText"
          :items-per-page="30"
          :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
          sort-by="created_at"
          class="table-cursor"
          v-bind:sort-desc="true"
          :loading="loading"
          :loading-text="$t('table.loading')"
      >
        <template v-slot:item.state="{ item }">
          <div class="d-flex justify-center">
            <ModeratedOperationState
              :state="item.state"
              :finished="item.finished"
              :authorized="item.authorized"
              :form-name="item.form_name"
              display="stepper-text"
              text-variant="state"
            />
          </div>
        </template>
        <template v-slot:item.created_at="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{
                  timeDifference(new Date(item.created_at))
                }}</span>
            </template>
            <span
            >{{ new Date(item.created_at).toISOString().substr(0, 10) }}
              {{ new Date(item.created_at).toTimeString().substr(0, 8) }}</span
            >
          </v-tooltip>
        </template>
        <template v-slot:item.form_name="{ item }">
          <div
            class="text-truncate"
            style="max-width:380px;"
          >{{ getFormName(item.form_name) }}<br><span class="text-caption">{{ item.title }}</span></div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            :to="(item.state === 'PV' || item.state === 'PA' || item.state === 'RJ') ? `/manage/forms/${item.object_type}/${item.form_name}/${item.id}` : `/manage/forms/process/${item.object_type}/${item.form_name}/${item.id}`"
            icon
            small
            class="mr-2"
            color="primary"
          >
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.owner="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ item.owner.first_name }}</span>
            </template>
            <span>{{ item.owner.first_name }} {{ item.owner.last_name }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.supervisor="{ item }">
          <v-tooltip 
            top
            v-if="item.supervisor && item.supervisor.first_name && item.supervisor.last_name"
          >
            <template v-slot:activator="{ on }">
                <span v-on="on">{{ item.supervisor.first_name }}</span>
            </template>
            <span>{{ item.supervisor.first_name }} {{ item.supervisor.last_name }}</span>
          </v-tooltip>
          <span v-else>-</span> 
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import investigatorTablesMethods from "../../mixins/investigatorTablesMethods";
import ModeratedOperationState from "../reusables/ModeratedOperationState";
export default {
  mixins: [investigatorTablesMethods],
  components: { ModeratedOperationState },
  data() {
    return {
      historic_search: "",
      loading: true,
      historic_forms: []
    };
  },
  computed: {
    pending_headers() {
      return [
        {
          text: this.$t("state.state"),
          value: "state",
          width: "15%"
        },
        {
          text: this.$t("formName"),
          value: "form_name",
          width: "40%"
        },
        { text: this.$t("owner"), value: "owner"},
        {
          text: this.$t("supervisor"),
          value: "supervisor",
        },
        { text: this.$t("create"), value: "created_at" },
        {
          text: this.$t("actions"),
          value: "actions",
          width: "10%",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    },
    historic_headers() {
      return [
        {
          text: this.$t("state.state"),
          value: "state",
          filterable: true,
          width: "10%",
          align: "center"
        },
        {
          text: this.$t("formName"),
          filterable: true,
          value: "form_name",
        },
        { text: this.$t("owner"), value: "owner", filterable: true,} ,
        {
          text: this.$t("supervisor"),
          value: "supervisor", filterable: true,
        },
        { text: this.$t("create"), value: "created_at" },
        {
          text: this.$t("actions"),
          value: "actions",
          width: "10%",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
    this.getAuthorizeFormsList();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/moderatedOperations/reviewHistory";
      axios
        .get(path)
        .then(response => {
          this.historic_forms = response.data.filter(form => form.finished || form.state === "RJ");
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    filterHistoricText (value, query, item) {

      let searchIn = [
        this.$t(item.form_name),
        item.owner.first_name,
        item.owner.last_name,
        item.supervisor ? item.supervisor.first_name : "",
        item.supervisor ? item.supervisor.last_name : "",
        item.created_at,
        item.title
      ].join(' ').toLocaleLowerCase();

      return query != null && item != null && 
        typeof query === 'string' &&
        searchIn.indexOf(query.toLocaleLowerCase()) !== -1
    },
  }
};
</script>
